import React from 'react'
import { ProjectionTooltipPoint, ProjectionTooltipProps } from '../../lib/types'
import { formatCompactCurrency } from './opportunity-detail.utils'

const ProjectionTooltip = ({
  active,
  payload,
  currencyCode,
  startingAmount,
}: ProjectionTooltipProps) => {
  if (!active || !payload?.length) return null

  const point = payload[0]?.payload as ProjectionTooltipPoint | undefined
  if (!point) return null

  return (
    <div className='opportunity-investment-projection-tooltip'>
      <div className='opportunity-investment-projection-tooltip-label'>Time: {point.label}</div>
      <div className='opportunity-investment-projection-tooltip-value'>
        Projected value: {formatCompactCurrency(point.value, currencyCode)}
      </div>
      <div className='opportunity-investment-projection-tooltip-value'>
        Projected income: {formatCompactCurrency(point.value - startingAmount, currencyCode)}
      </div>
    </div>
  )
}

export default ProjectionTooltip
